
const debug = false
// const debug = "PaletteProto"

export default class PaletteProto {

    public currentPalette   : string
    public isDarkMode       : boolean = false
    public defaultPaletteId : string

    public palettes         : any   // dict paltte ID -> Pallete values

    constructor(currentPalette:string, defaultPaletteId :string) {

        this.currentPalette     = currentPalette;
        this.defaultPaletteId   = defaultPaletteId;

        // this.setPalette(currentPalette)

        // debug && console.log(debug, 'constructor', this.palettes[this.currentPalette])
    }

    setPalette(palette:string) {

        // if (palette===this.currentPalette) return;

        // make sure palette exists
        // @ts-ignore
        if (!this.palettes[palette]) palette = this.defaultPaletteId

        this.currentPalette = palette;

        this.applyDOMCssVariables();
    }

    applyDOMCssVariables() {
        // @ts-ignore
        // const palette = this.palettes[this.currentPalette]
        // const root = document.querySelector(':root');

        // //******* Patch for test dynamic palette-white!!!!!!!!!! ***** //
        //
        // if (this.currentPalette.startsWith("light")) {
        //     // @ts-ignore
        //     root.style.setProperty('--palette-white', '#FFFFFF') // Goodday palette white
        // }
        //
        // if (this.currentPalette.startsWith("dark")) {
        //     // @ts-ignore
        //     root.style.setProperty('--palette-white', '#1A222C') // Goodday palette white
        // }
        //
        // //************* Patch end ****************//


        // for (let i=0; i<=11; i++) {
        //     // @ts-ignore
        //     root.style.setProperty('--palette-gray-'+i, '#'+palette[i])
        // }

        throw Error("#62344 Not implemented");
    }

    // do we need it?
    lightPalettes(): any[] {

        console.error("#02833 Not implemented");

        return []
    }

    getColorHEX(index:number) {
        // return this.palettes[this.currentPalette] ? '#{0}'.f(this.palettes[this.currentPalette][index]) : '#000000'

        return '#000000'
    }

    // darkPalettes() {
    //     return [
    //         'dark-1',
    //         'dark-2'
    //     ]
    // }
}
